import { render, staticRenderFns } from "./currency_hedge.vue?vue&type=template&id=0e398be2&scoped=true&"
import script from "./currency_hedge.vue?vue&type=script&lang=js&"
export * from "./currency_hedge.vue?vue&type=script&lang=js&"
import style0 from "./currency_hedge.vue?vue&type=style&index=0&id=0e398be2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e398be2",
  null
  
)

export default component.exports